<template>
  <header id="Header">
    <nav>
      <!-- logo -->
      <img class="logo" :src="logo" alt="" @click="toIndex_fn">
      <!-- 导航栏 -->
      <ul class="tabBar">
        <li v-for="(item,index) in tabBar" @click="active_fn(item.path,index)" :key="index"
            :class="{active:4===index,path:item.path}">
          <template v-if="item.children">
            <!-- 带下拉框 -->
            <a-dropdown>
              <div @click.prevent>
                {{ item.name }}
                <img class='anticon' :src="down_outline" alt="">
              </div>
              <template #overlay>
                <a-menu>
                  <a-menu-item v-for="(second,secondIndex) in item.children" :key="secondIndex">
                    <div class="secondDom" @click="second.path ? active_fn(second.path) : ''">
                      <div :class="second.children?'secondTitle':'underline secondTitle'">
                        <img v-if="second.icon" :src="second.icon" alt="">
                        {{ second.name }}
                      </div>
                      <dl class="threeDom" v-if="second.children && second.children.length">
                        <dd v-for="(three,threeIndex) in second.children" :key="threeIndex"
                            @click="three.path ? active_fn(three.path) : ''">
                          {{ three.name }}
                        </dd>
                      </dl>
                    </div>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
          <template v-else>
            <!-- 没有下拉框 -->
            {{ item.name }}
          </template>
        </li>
      </ul>
      <!-- 搜索 -->
      <div class="searchGloble" @click="searchGloble_fn">
        搜索
        <img :src="icon_search" alt="">
      </div>
      <!-- 头像 -->
      <div class="userInfo" v-if="userId_s">
        <a-dropdown>
          <img class="head" @click="toPersonal" :src="userAvatar_s?userAvatar_s:defaultAvatar" alt="">
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <div @click="exit_fn">退出</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
        <div class="growthSys_toast" v-if="growthSys_toast.type" @click="growthSys_toast={rewardValue: 0, type: false}">
          <b>任务达成，成长值</b><span>+{{ growthSys_toast.rewardValue }}</span><i>EXP</i>
        </div>
      </div>
      <div class="userInfo" v-else>
        <ul class="login">
          <li @click="onLogin_fn">登录</li>
          <li @click="onRegister_fn">注册</li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import Cookie from "js-cookie";
import {DownOutlined} from '@ant-design/icons-vue';
import {Badge, Dropdown, Menu} from 'ant-design-vue';
import {getPersonalWebsite} from "@/api";
import {syslogin, sysregister, isBrainMedPC, getUserId} from "@/utils/methods.js";

export default {
  name: "Header",
  components: {
    [Menu.name]: Menu,
    [Menu.Item.name]: Menu.Item,
    [Dropdown.name]: Dropdown,
    DownOutlined,
  },
  data() {
    return {
      navText: '返回官网',
      down_outline: require('@/assets/img/icon_down_outlined.png'),
      tabBar: [
        {
          name: '首页',
          path: '/'
        },
        {
          name: '资讯',
          path: '/info'
        },
        {
          name: '会议',
          path: '/meeting/home'
        },
        {
          name: '病例',
          path: '/case'
        },
        {
          name: '云课堂',
          path: '/mooc/#/'
        },
        {
          name: '全景手术',
          path: '/elabweb/holographic'
        },
        {
          name: '投审稿',
          path: 'medtion.com/my/personalFile.jspx',
        },
        {
          name: '更多',
          downoutline: true,
          children: [
            {
              name: '学术资源',
              icon: require('@/assets/img/icon_menu_resource.png'),
              children: [
                {
                  name: '投审稿',
                  path: 'medtion.com/my/personalFile.jspx',
                },
                {
                  name: '文章专栏',
                  path: '/column',
                },
                {
                  name: '指南共识',
                  path: '/guidance',
                },
                {
                  name: '精选编译',
                  path: '/compile',
                },
                {
                  name: '科室主页',
                  path: '/department/home',
                },
                {
                  name: '评分工具',
                  path: '/score',
                },
                {
                  name: '文献速览',
                  path: '/literature/home',
                },
                {
                  name: '招聘培训',
                  path: '/recruitment-training',
                },
                {
                  name: '藏书阁',
                  path: '/mall',
                },
                {
                  name: '话题圈子',
                  path: '/topic-circle',
                },
                {
                  name: '临床招募',
                  path: '/clinical',
                },
                {
                  name: '手术复盘',
                  path: '/elabweb',
                },
              ]
            },
            {
              name: '亚专业',
              icon: require('@/assets/img/icon_menu_submajor.png'),
              children: [
                {
                  name: '脑肿瘤',
                  path: '/channel/home?channelId=1&channelTitle=脑肿瘤&mpId=812&ocsId=812',
                },
                {
                  name: '脑血管',
                  path: '/channel/home?channelId=2&channelTitle=脑血管&mpId=813&ocsId=813',
                },
                {
                  name: '神经介入',
                  path: '/channel/home?channelId=4&channelTitle=神经介入&mpId=815&ocsId=815',
                },
                {
                  name: '功能',
                  path: '/channel/home?channelId=3&channelTitle=功能&mpId=814&ocsId=814',
                },
                {
                  name: '脊髓脊柱',
                  path: '/channel/home?channelId=5&channelTitle=脊髓脊柱&mpId=816&ocsId=816',
                },
                {
                  name: '创伤重症',
                  path: '/channel/home?channelId=6&channelTitle=创伤重症&mpId=817&ocsId=817',
                },
                {
                  name: '小儿',
                  path: '/channel/home?channelId=7&channelTitle=小儿&mpId=818&ocsId=818',
                },
                {
                  name: '神经内科',
                  path: '/channel/home?channelId=13&channelTitle=神经内科&mpId=1291&ocsId=1291',
                },
                {
                  name: '其他',
                  path: '/channel/home?channelId=8&channelTitle=其他&mpId=819&ocsId=819',
                }
              ],
            },
            {
              name: '医药器械',
              icon: require('@/assets/img/icon_menu_instrument.png'),
              children: [
                {
                  name: '介入',
                  path: '/bms/home/3?categoryCode=jieru',
                },
                {
                  name: '神外',
                  path: '/bms/home/89?categoryCode=shenwai',
                },
                {
                  name: '药品',
                  path: '/bms/home/4?categoryCode=yaopin',
                },
                {
                  name: '诊断',
                  path: '/bms/home/40?categoryCode=zhenduan',
                },
              ]
            }
          ]
        },
        {
          name: '关于我们',
          path: '/introduce?optionActive=aboutUs'
        },
      ],
      active: 0,
      userId_s: Cookie.get('medtion_member_id'),
      userAvatar_s: '',
      defaultAvatar: require('@a/img/user_default_img.png'),
      logo: require('@a/img/logo.png'),
      icon_search: require('@a/img/icon_search2.png'),
      searchVal_s: '',
      growthSys_toast: {type: false},
    }
  },
  // components: {},
  computed: {
    growthSys_toast_cpu() {
      return this.$store.state.growthSys_toast;
    }
  },
  methods: {
    // 登录
    onLogin_fn() {
      syslogin();
    },
    // 注册
    onRegister_fn() {
      sysregister();
    },
    active_fn(path, index) {
      if (path) {
        this.active = index;
      }else{
        return;
      }
      if (/medtion.com/.test(path)) {
        location.href = (process.env.NODE_ENV === "production" ? "http://www." : "http://dev.") + path;
      } else {
        location.href = window.location.origin + path;
      }
    },
    toIndex_fn() {
      if (/#\/$/.test(location.href)) {
        location.href = '/'
      } else {
        this.$router.push('/');
      }
    },
    // 获取用户信息
    getUserInfo_fn() {
      if (this.userId_s) {
        if(Cookie.get('medtion_user_only_sign')){
          let userInfo = JSON.parse(Cookie.get('medtion_user_only_sign'));
          if(userInfo.identity === 7){
            window.location.href='/access-restriction';
            return;
          }
        }
        getPersonalWebsite({
          profileUserId: this.userId_s
        }).then(res => {
          if (res.data.code === 1) {
            if(res.data.data.identity === 7){
              window.location.href='/access-restriction';
            }
            this.userAvatar_s = res.data.data.avatarAddress;
          }
        })
      }
    },
    // 设置临时nav 返回官网首页
    navText_fn() {
      if (/#\/$/.test(location.href)) {
        this.navText = '脑医汇首页';
      } else {
        this.navText = '云课堂'
      }
    },
    // 个人中心
    toPersonal() {
      let href = '/user-center?profileUserId=' + this.userId_s
      if (isBrainMedPC()) {
        href += '&token=' + Cookie.get('wtoken')
      }
      window.open(href, '_blank');
    },
    // 退出登录
    exit_fn() {
      Cookie.set('medtion_member_id', '', {expires: -1, path: '/'});
      localStorage.removeItem('timeDisplayYun')
      localStorage.removeItem('luckyDrawPopClose')
      localStorage.removeItem('recodeDateTime')
      localStorage.removeItem('timeDisplay')
      localStorage.removeItem('luckyDrawArticleShowTips')
      localStorage.removeItem('luckyDrawPopShow')
      localStorage.removeItem('localArticleRecode')
      localStorage.removeItem('luckyDrawPopShowTips')
      localStorage.removeItem("recodeDrawTimes")
      location.href = '/logout.jspx?fallbackUrl=' + encodeURIComponent(location.href);
    },
    // 云课堂搜索
    search_fn() {
      if (this.searchVal_s) {
        if (!/search/.test(this.$route.fullPath)) {
          this.$router.push('/search/' + this.searchVal_s);
        } else {
          this.$router.replace('/search/' + this.searchVal_s);
        }
      }
    },
    searchGloble_fn() {
      location.href = '/search'
    }
  },
  created() {
    this.getUserInfo_fn();
  },
  mounted() {
    this.navText_fn();
  },
  watch: {
    $route(to, from) {
      this.navText_fn();
    },
    growthSys_toast_cpu: {
      handler(n, o) {
        this.growthSys_toast = n;
        setTimeout(() => {
          this.growthSys_toast.type = false;
        }, 2500)
      },
      deep: true
    }
  },
}
</script>

<style scoped lang="scss">
header {
  background: #0581ce;
  margin-bottom: 20px;
  /*box-shadow: 0 0 10px #eee;*/
  border-bottom: 1px solid #F0F0F0;
  box-shadow: 0 0 10px #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 99;
}

nav {
  @extend %safetyWidth;
  display: flex;
  align-items: center;
}

.logo {
  width: 56px;
  background: #6fc2f5;
  margin-right: 10px;
}

.tabBar {
  display: flex;
  user-select: none;
  margin-left: 18px;

  li {
    padding: 0 10px;
    margin: 0 2px;
    line-height: 60px;
    font-size: 16px;
    text-align: center;
    flex: 0 0 auto;
    color: hsla(0, 0%, 100%, .9);
    position: relative;
    &.path{
      cursor: pointer;
    }


    :deep(.ant-dropdown-trigger){
      display: flex;
      align-items: center;
      .anticon{
        width: 12px;
        height: 12px;
        margin-left: 6px;
        transition: all .2s;
        transform: rotate(180deg);
      }
      &:hover .anticon{
        transform: rotate(0deg);
        transition: all .2s;
      }
    }



    &.active:after {
      content: '';
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      bottom: 20%;
      width: 12px;
      height: 4px;
      border-radius: 21px;
      background: #fff;
    }

    .anticon {
      font-size: 10px!important;
    }
  }
}

// 下拉框样式
.secondDom {
  display: flex;
  flex-direction: column;
  padding-top: 4px;

  .secondTitle {
    display: flex;
    align-items: center;
    font-size: 14px;

    &.underline{
      background: #fff;
      color: #457999;

      &:hover {
        color: #0581ce;
        text-decoration: underline;
      }
    }

    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }

  .threeDom {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 12px;
    margin: 12px 0;

    dd {
      width: 86px;
      line-height: 28px;
      font-size: 14px;
      text-align: center;
      color: #304B64;
      background: linear-gradient(0deg, rgba(112, 138, 162, 0.04) 0%, rgba(112, 138, 162, 0.04) 100%), #FFF;
      border-radius: 4px;
      border: 1px solid rgba(112, 138, 162, 0.20);
      cursor: pointer;

      &:hover {
        background: linear-gradient(0deg, rgba(48, 75, 100, 0.10) 0%, rgba(48, 75, 100, 0.10) 100%), #FFF;
      }
    }
  }
}

:deep(.ant-dropdown-menu-item), :deep(.ant-dropdown-menu-submenu-title){
  padding: 5px 12px 0;
  cursor: default;
  &:hover{
    background: transparent!important;
  }
}

.searchGloble {
  background: #fff;
  color: #0581ce;
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 60px;
  text-align: center;
  padding: 0 10px;
  margin-left: auto;
  flex: 0 0 auto;
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
    margin-left: 6px;
  }
}

.search {
  background: rgba(238, 238, 238, 0.9);
  border-radius: 18px;
  padding: 8px 16px;
  width: 280px;
  display: flex;
  margin-left: auto;
  align-items: center;

  input {
    line-height: 20px;
    font-size: 14px;
    flex: 1;
    color: #333;
  }

  img {
    width: 16px;
    height: 16px;
  }
}

.user {
  margin-left: 34px;
  width: 178px;
  display: flex;
  justify-content: space-between;

  img {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: #6fc2f5;
  }
}

.userInfo {
  height: 34px;
  margin-left: 20px;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
  flex: 0 0 auto;

  .head {
    height: 34px;
    width: 34px;
    border-radius: 50%;
  }

  .login {
    line-height: 34px;
    display: flex;
    font-size: 16px;

    li {
      flex: 0 0 auto;
      display: flex;
      align-items: center;

      &:nth-of-type(1) {
        color: #fff;

        &::after {
          content: '';
          display: inline-block;
          width: 1px;
          height: 12px;
          background: rgb(178, 178, 178);
          margin: 0 10px;
        }
      }

      &:nth-of-type(2) {
        color: #fff;
      }
    }
  }
}

.growthSys_toast {
  position: absolute;
  display: flex;
  align-items: center;
  top: 60px;
  right: -25px;
  z-index: 10;
  background: rgba(51, 51, 51, 0.95);
  font-size: 16px;
  line-height: 50px;
  padding: 0 16px;
  border-radius: 6px;
  width: 236px;
  justify-content: center;

  &::after {
    content: '';
    position: absolute;
    top: -20px;
    right: 29px;
    width: 10px;
    height: 10px;
    border: 10px solid rgba(51, 51, 51, 0.95);
    border-right-color: transparent;
    border-top-color: transparent;
    border-left-color: transparent;
    /*background: radial-gradient(circle at 0 0, transparent, transparent 9.5px, #6ecb15 10px, #6ecb15);*/
  }

  b {
    flex: 0 0 auto;
    color: #fff;
  }

  span {
    color: #FF9600;
    font-size: 20px;
  }

  i {
    color: #FF9600;
    font-size: 14px;
  }
}
</style>
